import AscButton from "../../../../AscButton/AscButton";
import AscHeading from "../../../../AscTypography/AscHeading/AscHeading";
import AscActivityAnswerCardForm from "../../../AscActivityAnswerCardForm/AscActivityAnswerCardForm";

import styles from "./AscActivityTimeline.module.scss";
import { useEffect } from "react";
import AscSelectActivityQuestionAnswerForm from "../../../AscSelectActivityQuestionAnswerForm/AscSelectActivityQuestionAnswerForm";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";
import { v4 as uuidv4 } from "uuid";

export default function AscActivityTimeline() {
  const formik = useAscAddModuleActivitiesForm();

  function handleDeleteCard(index: number) {
    const newCards = [...(formik?.values?.timeline?.questions?.cards || [])];

    newCards.splice(index, 1);

    if (newCards.length === 0) {
      newCards.push({ name: "", id: uuidv4() });
    }
    formik.setFieldValue("timeline.questions.cards", newCards);
  }

  function handleDeleteGroup(index: number) {
    const newGroups = [...(formik?.values?.timeline?.questions?.groups || [])];
    newGroups.splice(index, 1);
    if (newGroups.length === 0) {
      newGroups.push({ name: "" });
    }
    formik.setFieldValue("timeline.questions.groups", newGroups);

    //remove group from correct answers as well
    const newCorrectAnswers = [
      ...(formik?.values?.timeline?.questions?.correctAnswers || []),
    ];
    newCorrectAnswers.splice(index, 1);
    formik.setFieldValue(
      "timeline.questions.correctAnswers",
      newCorrectAnswers
    );
  }

  function addCard() {
    formik.setFieldValue("timeline.questions.cards", [
      ...(formik?.values?.timeline?.questions?.cards || []),
      {
        id: uuidv4(),
        name: "",
      },
    ]);
  }

  function addGroup() {
    formik.setFieldValue("timeline.questions.groups", [
      ...(formik?.values?.timeline?.questions?.groups || []),
      { name: "" },
    ]);
  }

  function handleAnswerChange(
    index: number,
    question: {
      question?: string;
      answers?: string[];
    }
  ) {
    const newQuestions = [
      ...(formik?.values?.timeline?.questions?.correctAnswers || []),
    ];

    newQuestions[index] = {
      name: question.question || "",
      answers: question.answers || [],
    };
    formik.setFieldValue("timeline.questions.correctAnswers", newQuestions);
  }

  //initialize cards and groups
  useEffect(() => {
    if (formik?.values?.timeline?.questions?.cards?.length === 0) {
      addCard();
    }
    if (formik?.values?.timeline?.questions?.groups?.length === 0) {
      addGroup();
    }
  }, []);

  return (
    <div className={styles.ground}>
      <div className={styles.headerGround}>
        <AscHeading className={styles.header} level={6}>
          Answer cards
        </AscHeading>

        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={addCard}
        >
          Add card <span>+</span>
        </AscButton>
      </div>
      {formik?.values?.timeline?.questions?.cards?.map(
        (card, index: number) => {
          const cardInUse =
            formik?.values?.timeline?.questions?.correctAnswers?.some((ca) =>
              ca?.answers?.includes(card?.id)
            );
          return (
            <AscActivityAnswerCardForm
              key={card?.id}
              name={`timeline.questions.cards[${index}].name`}
              value={card.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              canDelete={!cardInUse}
              onDelete={() => handleDeleteCard(index)}
            />
          );
        }
      )}
      <div className={styles.headerGround}>
        <AscHeading className={styles.header} level={6}>
          Groups
        </AscHeading>

        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={addGroup}
        >
          Add group <span>+</span>
        </AscButton>
      </div>
      {formik?.values?.timeline?.questions?.groups?.map(
        (group, index: number) => (
          <AscActivityAnswerCardForm
            key={index}
            name={`timeline.questions.groups[${index}].name`}
            value={group.name}
            onChange={(e) => {
              formik.handleChange(e);
              formik.setFieldValue(
                `timeline.questions.correctAnswers[${index}].name`,
                e.target.value
              );
            }}
            onBlur={formik.handleBlur}
            canDelete
            onDelete={() => handleDeleteGroup(index)}
          />
        )
      )}
      <AscHeading className={styles.title} level={6}>
        Correct Answers
      </AscHeading>
      {formik?.values?.timeline?.questions?.correctAnswers
        ?.filter((g) => g?.name)
        ?.map((ca, index: number, arr) => {
          return (
            <AscSelectActivityQuestionAnswerForm
              key={index}
              questionFieldDisabled
              multiple
              selectOptions={
                formik?.values?.timeline?.questions?.cards?.map((card) => ({
                  name: card?.name,
                  value: card?.id,
                  disabled:
                    !ca.answers?.includes(card?.id) &&
                    arr?.some((a) => a?.answers?.includes(card?.id)),
                })) || []
              }
              value={{
                question: ca?.name,
                answers: ca?.answers,
              }}
              onChange={(q) => handleAnswerChange(index, q)}
              hideDelete
            />
          );
        })}
    </div>
  );
}
